import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Department } from 'requests/nswag/atlas/AtlasClient';
import { useLocationContext } from './Location/LocationProvider';

type DepartmentDotMenuProps = {
  department: Department;
};

function DepartmentDotMenu({ department }: DepartmentDotMenuProps) {
  const [menuAnchorEl, setMenuAnchorEl] = useState<(EventTarget & Element) | null>(null);

  const { setDeleteLocation, setRenameLocation, setCreateLocation } = useLocationContext();

  function onMenuClick(event: React.MouseEvent<HTMLElement>) {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  }

  function onMenuClose() {
    setMenuAnchorEl(null);
  }

  const open = Boolean(menuAnchorEl);
  return (
    <>
      <IconButton style={{ padding: 0 }} onClick={onMenuClick} size="large">
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        keepMounted
        open={open}
        onClose={onMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            setCreateLocation(department);
            onMenuClose();
          }}
        >
          <Typography>Create apartment</Typography>
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            setRenameLocation(department);
            onMenuClose();
          }}
        >
          <Typography>Rename department</Typography>
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            setDeleteLocation(department);
            onMenuClose();
          }}
        >
          <Typography>Delete department</Typography>
        </MenuItem>
      </Menu>
    </>
  );
}

export default DepartmentDotMenu;
